import { FC } from 'react'
import {
  OrderDetailContentContainer,
  OrderDetailContentLeftContent,
  OrderDetailContentName,
} from '../order.styled'
import { OrderDetailContentImageProps } from '../order.types'

export const OrderDetailContent: FC<OrderDetailContentImageProps> = ({
  name,
}) => {
  return (
    <OrderDetailContentContainer>
      <OrderDetailContentLeftContent>
        <div>
          <OrderDetailContentName>{name}</OrderDetailContentName>
        </div>
      </OrderDetailContentLeftContent>
    </OrderDetailContentContainer>
  )
}
